import produce from "immer";
import { MarketingCampaignActions } from ".";
import { IStoreState } from "../initialStoreState";
import { initialMarketingCampaignState } from "./marketCampaign.types";
import {
  CLEAR_MARKET_CAMPAIGN_STATE,
  FETCH_MARKET_CAMPAIGN_FAILED,
  FETCH_MARKET_CAMPAIGN_PROGRESS,
  FETCH_MARKET_CAMPAIGN_SUCCESS,
  FETCH_MARKETING_CAMPAIGN_LIST_FAILED,
  FETCH_MARKETING_CAMPAIGN_LIST_PROGRESS,
  FETCH_MARKETING_CAMPAIGN_LIST_SUCCESS,
  FETCH_MARKETING_WHATSAPP_TEMPLATE_FAILED,
  FETCH_MARKETING_WHATSAPP_TEMPLATE_LIST_FAILED,
  FETCH_MARKETING_WHATSAPP_TEMPLATE_LIST_PROGRESS,
  FETCH_MARKETING_WHATSAPP_TEMPLATE_LIST_SUCCESS,
  FETCH_MARKETING_WHATSAPP_TEMPLATE_PROGRESS,
  FETCH_MARKETING_WHATSAPP_TEMPLATE_SUCCESS,
} from "./marketCampaignActions";
import { LoadState } from "../../constants/enums";

export const marketingCampaignReducer = (
  state: IStoreState["marketingCampaign"] = initialMarketingCampaignState,
  action: MarketingCampaignActions
) => {
  switch (action.type) {
    case FETCH_MARKETING_WHATSAPP_TEMPLATE_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.whatsAppTemplate.loading = LoadState.InProgress;
        draftState.whatsAppTemplate.list = [];
      });
      return newState;
    }
    case FETCH_MARKETING_WHATSAPP_TEMPLATE_LIST_SUCCESS: {
      const { list } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.whatsAppTemplate.loading = LoadState.Loaded;
        draftState.whatsAppTemplate.list = list;
      });
      return newState;
    }
    case FETCH_MARKETING_WHATSAPP_TEMPLATE_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.whatsAppTemplate.loading = LoadState.InProgress;
        draftState.whatsAppTemplate.list = [];
      });
      return newState;
    }
    case FETCH_MARKETING_WHATSAPP_TEMPLATE_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.whatsAppTemplate.dataLoading = LoadState.InProgress;
        draftState.whatsAppTemplate.data =
          initialMarketingCampaignState.whatsAppTemplate.data;
      });
      return newState;
    }
    case FETCH_MARKETING_WHATSAPP_TEMPLATE_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.whatsAppTemplate.dataLoading = LoadState.Loaded;
        draftState.whatsAppTemplate.data = data;
      });
      return newState;
    }
    case FETCH_MARKETING_WHATSAPP_TEMPLATE_FAILED: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.whatsAppTemplate.dataLoading = LoadState.Failed;
        draftState.whatsAppTemplate.error = errorMessage;
      });
      return newState;
    }
    case FETCH_MARKETING_CAMPAIGN_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.marketCampain.loading = LoadState.InProgress;
        draftState.marketCampain.list = [];
      });
      return newState;
    }
    case FETCH_MARKETING_CAMPAIGN_LIST_SUCCESS: {
      const { list } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.marketCampain.loading = LoadState.Loaded;
        draftState.marketCampain.list = list;
      });
      return newState;
    }
    case FETCH_MARKETING_CAMPAIGN_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.marketCampain.loading = LoadState.InProgress;
        draftState.marketCampain.list = [];
      });
      return newState;
    }
    case FETCH_MARKET_CAMPAIGN_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.marketCampain.loading = LoadState.InProgress;
        draftState.marketCampain.data =
          initialMarketingCampaignState["marketCampain"].data;
      });
      return newState;
    }
    case FETCH_MARKET_CAMPAIGN_SUCCESS: {
      const { lead } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.marketCampain.loading = LoadState.Loaded;
        draftState.marketCampain.data = lead;
      });
      return newState;
    }
    case FETCH_MARKET_CAMPAIGN_FAILED: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.marketCampain.loading = LoadState.Failed;
        draftState.marketCampain.error = errorMessage;
      });
      return newState;
    }
    case CLEAR_MARKET_CAMPAIGN_STATE: {
      return initialMarketingCampaignState;
    }

    default: {
      return state;
    }
  }
};
